module.exports = __webpack_public_path__ + "static/media/dice-two.752bf18a.svg";